import { attributeValueComparatorWithSorter } from '@/utils/attributes';

/**
 * Called to create a sorter.
 *
 * Returns a sorting function where the values are obtain and compared
 *
 * @param getter: function
 */
export function createSorter(getter, sortedReverse) {
    return (a, b) => {
        // Convert
        const valueA = getter(a);
        const valueB = getter(b);
        // Value comparison
        return attributeValueComparatorWithSorter(valueA, valueB, sortedReverse);
    };
}

/**
 * Called to create a sorter, with multiple sorters.
 *
 * Returns a sorting function where the values are obtain and compared and organized by each sort
 *
 * @param sorters: list of functions
 */
export function chainSorters(sorters) {
    return sorters.reduce(
        (sum, getter) => {
            return (a, b) => {
                const upstream = sum(a, b);
                return upstream !== 0 ? upstream : getter(a, b);
            };
        },
        () => 0,
    );
}

/**
 * Compare two integers.
 *
 * Returns the difference between a and b. If sortedReverse = true then returns the difference between b and a
 *
 * @param a: integer
 * @param b: integer
 * @param sortedReverse: bool
 */
export function getDifference(a, b, sortedReverse) {
    return sortedReverse ? b - a : a - b;
}

/**
 * Called to create a sorter for a list of values.
 *
 * Returns a sorting function where the values are obtain and compared
 *
 * @param getter: function
 * @param sortAttribute: string
 * @param sortedReverse: bool
 * @param attribute: string
 */
export function createSorterList(getter, sortAttribute, sortedReverse, attributeValue, typeValue) {
    const sortValue = sortedReverse ? -1 : 1;
    return (a, b) => {
        const valuesA = getter(a);
        const valuesB = getter(b);
        if (valuesA.length === 0 && valuesB.length === 0) {
            return 0;
        }
        if (valuesA.length === 0) {
            return 1;
        }
        if (valuesB.length === 0) {
            return -1;
        }
        const valueA = valuesA[0];
        const valueB = valuesB[0];
        const sortOptions = sortAttribute.split(',');

        if (sortOptions.includes(valueA[typeValue])) {
            if (sortOptions.includes(valueB[typeValue])) {
                return sortValue * (valueA[attributeValue] - valueB[attributeValue]);
            } else {
                return -1;
            }
        }
        if (sortOptions.includes(valueB[typeValue])) {
            return 1;
        }
        return sortValue * (valueA[attributeValue] - valueB[attributeValue]);
    };
}
